import { render, staticRenderFns } from "./ScoreboardBOActions.vue?vue&type=template&id=7ad3c38a"
import script from "./ScoreboardBOActions.vue?vue&type=script&lang=js"
export * from "./ScoreboardBOActions.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardBOActions.vue?vue&type=style&index=0&id=7ad3c38a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports